export default __webpack_public_path__ + "static/media/about.30dc9feb.svg";